import createCache from '@emotion/cache';
import rtlPlugin from 'stylis-plugin-rtl';
import { prefixer } from 'stylis';

function namespacePlugin(namespace) {
    return (element) => {
        const skipNamespaceSelector = "#skip-namespace";
        if (element.type === "rule" && Array.isArray(element.props) && element.root?.type !== "@keyframes") {
            element.props = element.props.map(value => {
                if (value.startsWith(skipNamespaceSelector))
                    return value.replace(`${skipNamespaceSelector} `, "").replace(skipNamespaceSelector, "");
                if (value.startsWith(namespace) || value.startsWith("&"))
                    return value;
                return `${namespace} ${value}`;
            });
        }
    };
}
function createEmotionCache({ key, rtl, namespace }) {
    const namespaceKey = key === "header" ? `#platform_modernisation_${key}` : `#epm_${key}`;
    return createCache({
        key,
        stylisPlugins: [prefixer, namespace && namespacePlugin(namespaceKey), rtl && rtlPlugin].filter(Boolean),
    });
}

export { createEmotionCache };
